// extracted by mini-css-extract-plugin
module.exports = {"boxContain":"styles_boxContain__Yb4lO","colorContainer":"styles_colorContainer__Wc72o"};